import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'
import PaginatedResponse from '@/types/PaginatedResponse'
import Activity from '@/types/Activity'

export default class ActivityService {
  async index(page: number, filters: string, per_page: number | undefined = 15): Promise<AxiosResponse<PaginatedResponse<Activity>>> {
    const _filters = new URLSearchParams()

    filters.split('&').forEach((pair) => {
      const [key, value] = pair.split('=')
      if (value) _filters.set(key, value)
    })

    return await http.get<PaginatedResponse<Activity>>(
      `/api/v1/office/activities?page=${page}&${_filters}&per_page=${per_page}`,
    )
  }
}
